import ActionConstants from "../action-constants"
import Action from "./Action";

class ReviewOrderActions extends Action {
    static insideReviewOrder(data: boolean) {
        return {
            type: ActionConstants.SHOW_REVIEW_ORDER,
            payload: {
                data
            }
        }
    }
}

export default ReviewOrderActions;